export default function ConfirmedBooking() {
  return (
    <main className="page-main">
      <section className="confirmed-booking">
        <div className="section-intro">
          <span className="eyebrow">Booking confirmed</span>
          <h1>Your reservation is confirmed!</h1>
          <p>Thank you for choosing us. We look forward to serving you on your selected date and time.</p>
        </div>
      </section>
    </main>
  );
}
